import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './hooks/useLanguage';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { HomePage } from './pages/HomePage';
import { IbizaAirportTransfer } from './pages/IbizaAirportTransfer';
import { IbizaVillaTransfer } from './pages/IbizaVillaTransfer';
import { IbizaNightDriver } from './pages/IbizaNightDriver';
import { IbizaGroupTransfer } from './pages/IbizaGroupTransfer';
import { SitemapXml } from './pages/SitemapXml';
import { RobotsTxt } from './pages/RobotsTxt';
function AppLayout() {
  const location = useLocation();
  const isRawRoute = location.pathname === '/sitemap.xml' || location.pathname === '/robots.txt';
  if (isRawRoute) {
    return <Routes data-id="element-0">
        <Route path="/sitemap.xml" element={<SitemapXml data-id="element-2" />} data-id="element-1" />
        <Route path="/robots.txt" element={<RobotsTxt data-id="element-4" />} data-id="element-3" />
      </Routes>;
  }
  return <div className="min-h-screen flex flex-col w-full overflow-x-hidden" data-id="element-5">
      <Header data-id="element-6" />
      <Routes data-id="element-7">
        <Route path="/" element={<HomePage data-id="element-9" />} data-id="element-8" />
        <Route path="/ibiza-airport-transfer" element={<IbizaAirportTransfer data-id="element-11" />} data-id="element-10" />
        <Route path="/ibiza-villa-transfer" element={<IbizaVillaTransfer data-id="element-13" />} data-id="element-12" />
        <Route path="/ibiza-night-driver" element={<IbizaNightDriver data-id="element-15" />} data-id="element-14" />
        <Route path="/ibiza-group-transfer" element={<IbizaGroupTransfer data-id="element-17" />} data-id="element-16" />
      </Routes>
      <Footer data-id="element-18" />
      <FloatingWhatsApp data-id="element-19" />
    </div>;
}
export function App() {
  return <LanguageProvider data-id="element-20">
      <AppLayout data-id="element-21" />
    </LanguageProvider>;
}